import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { Outlet } from 'react-router-dom';
import TabPanel from "../../components/common/tabpannel/Tabpannel";
import { useLocation, useNavigate } from "react-router-dom";
import Eventstab from "./events/Events";
import VolenteerTab from "./volunteeroppertunity/Volunteeroppertunity";
import ClubsTab  from "./clubs/Clubs";
import ForumsTab  from "./forums/Forums";

const CampusandCommunity = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const navigate = useNavigate(); 
    const location = useLocation(); 

    useEffect(() => {
        if (location.pathname === "/campusandcommunity/events") {
            setSelectedTab(0);
        } else if (location.pathname === "/campusandcommunity/volunteeroppertunities") {
            setSelectedTab(1);
        }else if (location.pathname === "/campusandcommunity/clubs") {
            setSelectedTab(2);
         }else if (location.pathname === "/campusandcommunity/forums") {
            setSelectedTab(3);
        }
    }, [location.pathname]);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        if (newValue === 0) {
            navigate("/campusandcommunity/events");
        } else if (newValue === 1) {
            navigate("/campusandcommunity/volunteeroppertunities");
        }else if (newValue === 2) {
            navigate("/campusandcommunity/clubs");
        }else if (newValue === 3) {
            navigate("/campusandcommunity/forums");
        }
    };

    return(
    <div>

        <div className="p-5">
            <TabPanel value={selectedTab} index={0}>
                <Eventstab />
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
                <VolenteerTab />
            </TabPanel>
            <TabPanel value={selectedTab} index={2}>
                <ClubsTab />
            </TabPanel>
        </div>
    </div>
    )
}

export default CampusandCommunity;